import { render } from "./KpiComponent.vue?vue&type=template&id=bbee1784&scoped=true"
import script from "./KpiComponent.vue?vue&type=script&lang=js"
export * from "./KpiComponent.vue?vue&type=script&lang=js"

import "./KpiComponent.vue?vue&type=style&index=0&id=bbee1784&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbee1784"]])

export default __exports__